var common = require("../../utiles/common.js")

module.exports = {
    register: function () {
        document.createElement('logout')
        ko.components.register('logout', {
            viewModel: function (params) {
                common.fetch("/auth/logout", {
                    method: "POST", success: function () {
                        localStorage.clear();
                        sessionStorage.clear();
                        sessionStorage.setItem("spnego",true);
                        sessionStorage.setItem("isWinLogout",true);
                        common.redirectTo("/#/");
                    }
                });
            },
            template: require("./Logout.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/logout/Logout.js
// module id = 170
// module chunks = 0